/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgAppForm from './OrgAppForm';
import { useParams } from 'react-router-dom';
import { createOrgApp } from '../../../../../../../services/organization/OrgApp';
import { getAllAppsByOrgID, getAllOrgsApps } from '../../../../../../../store/reducers/organization/orgApp/orgAppAction';

const OrgAppCreation = ({ handleClose }) => {
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, applicationID }) => {
        try {
            await createOrgApp({ organizationID, applicationID })
            toast.success('Organization Application was registred successfully');
            handleClose();
            if (orgid) {
                await dispatch(getAllAppsByOrgID({ 'organizationID': orgid })).unwrap()
            } else {
                await dispatch(getAllOrgsApps()).unwrap();
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid : '',
                    applicationID: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    applicationID: Yup.string().required('Application is required.')

                })}
                onSubmit={(
                    values
                ) => {
                     handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgAppForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}



export default OrgAppCreation;